import React, { useState } from 'react';
import {
  Text,
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useMediaQuery,
  useDisclosure,
} from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { getDashboard, getIsPageBarOpen, getSelectedPage } from 'redux/DashboardSliceV2';
import DownloadIcon from 'components/Icons/DownloadIcon';
import SinglePageIcon from 'components/Icons/SinglePageIcon';
import MultiPageIcon from 'components/Icons/MultiPageIcon';

import PreviewModal from './PreviewModal';

const ExportButtonNew = () => {
  const dashboard = useSelector(getDashboard);
  const isPageBarOpen = useSelector(getIsPageBarOpen);
  const currentPage = useSelector(getSelectedPage);
  const isSmallDevice = useMediaQuery('(min-width: 1024px)') && isPageBarOpen;
  const pages = dashboard?.pages || [];
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedPages, setSelectedPages] = useState<any[]>([]);

  const handleExportAllPages = () => {
    setSelectedPages([...pages]);
    onOpen();
  };

  const handleExportCurrentPage = () => {
    if (currentPage) {
      setSelectedPages([currentPage]);
      onOpen();
    }
  };

  const ExportMenuButton = isSmallDevice ? (
    <IconButton
      as={MenuButton}
      aria-label='Export'
      icon={<DownloadIcon />}
      backgroundColor='#5A58AB'
      borderRadius='sm'
      height='40px'
      border='none'
      fontSize={'md'}
      fontWeight={'400'}
      width={'fit-content'}
      title={'Export'}
      padding={'.5rem 1rem'}
      color='white'
    />
  ) : (
    <Button
      as={MenuButton}
      backgroundColor='#5A58AB'
      borderRadius='sm'
      height='40px'
      leftIcon={<DownloadIcon />}
      fontSize={'md'}
      border='none'
      fontWeight={'400'}
      width={'fit-content'}
      title={'Export'}
      padding={'.5rem 1rem'}
      color='white'
    >
      Export
    </Button>
  );

  return (
    <>
      <Menu closeOnSelect={true}>
        {ExportMenuButton}
        <MenuList>
          <MenuItem
            onClick={handleExportAllPages}
            icon={<MultiPageIcon />}
            isDisabled={!pages || pages.length === 0}
          >
            <Text fontFamily='regular_roboto'>Export All Pages</Text>
          </MenuItem>

          <MenuItem
            onClick={handleExportCurrentPage}
            icon={<SinglePageIcon />}
            isDisabled={!currentPage}
          >
            <Text fontFamily='regular_roboto'>Export Current Page</Text>
          </MenuItem>
        </MenuList>
      </Menu>

      <PreviewModal
        isOpen={isOpen}
        onClose={() => {
          setSelectedPages([]);
          onClose();
        }}
        selectedPages={selectedPages}
      />
    </>
  );
};

export default ExportButtonNew;
